import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

import type { CommonService } from "./service"

export const deleteService = async (
  serviceId: CommonService["id"]
) => {
  await api.delete(`/beepaidgo/services/${serviceId}/`)

  queryClient.invalidateQueries([SERVICES_QUERY_KEY])
}
